import React from "react";
import { Box, Container, Typography } from "@mui/material";
import LoginForm from "../components/forms/Login";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Connexion() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: { xs: 2, sm: 3 }, backgroundColor: 'primary.main', minHeight: '100vh', justifyContent: 'center' }}>
            <a href="/"><img src={require('../assets/logo-esdras7.png')} alt="Logo" style={{ width: '90vw', maxWidth: '350px', display: 'block' }} /></a>
            
            <Container maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: { xs: '280px', sm: '300px' }, width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: { xs: 2, sm: 3 }, borderRadius: 2, mb: 4 }}>
                <LoginForm {...{onLogin:()=>navigate('/')}} />
            </Container> 
        </Box>
    );
}